import { FaShoppingCart } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom/dist';
import "../index.css";

const Navbar = () => {
  const {Cart}=useSelector((state)=>state);
  const numberOfItems=Cart.length;
  return <div className="bg-[#0F172A] ">
    <div className='w-3/4 min-w-[350px] flex flex-row justify-between mx-auto py-4'>
    <div>
      <NavLink to={'/'}>
              <img src="https://codehelp-shopping-cart.netlify.app/logo.png" loading="lazy" alt="LOGO" width={180}/>
      </NavLink>
      
    </div>
    <div className='text-white flex flex-row gap-7 items-center'>
      <NavLink to={"/"}>
      <div className='text-xl'>
        Home
      </div>
      </NavLink>
     
     <NavLink to={"/cart"}>
     <div className='text-3xl relative'>
      <div className='text-[14px] w-6 h-6  bg-green-500 rounded-full flex items-center justify-center absolute -right-2 -top-2 animate-bounce '>
        {numberOfItems}
      </div>
      <FaShoppingCart/>
      </div>
     </NavLink>
     
    </div>

    </div>
    
  </div>;
};

export default Navbar;
